import React, { FC } from "react";

import * as styles from "./styles.module.scss";

import "~css/animations/loadingGooey.scss";

type Props = {
  className?: string;
  changeColor?: boolean;
  isCoverLetter?: boolean;
};

const PageDotsLoading: FC<Props> = ({ className, changeColor }) => {
  const themeStyle = changeColor ? `${styles.dot}` : "";

  return (
    <div className={className}>
      <div className={`gooey`}>
        <span className={`dot ${themeStyle}`} />
        <div className="dots">
          {Array(3)
            .fill(0)
            .map((item, index) => {
              return <span key={index} className={themeStyle} />;
            })}
        </div>
      </div>
    </div>
  );
};

export default PageDotsLoading;
